import { createSelector } from 'reselect';


export const annualEnergyValueForYear = (year, prevEnergyValue, state) => {
    const {
        annualInflation, energyValue,
    } = state.utility;


    if (year === 1) return energyValue;

    return prevEnergyValue * (1 + annualInflation / 100);
};

const totalFixed = (state) => {
    const { aFixedCharge, mFixedCharge } = state.utility;
    const { annualMonth } = state.settings;

    let total = 0;
    const values = Object.values(mFixedCharge);
    for (let i = 0; i < values.length; i += 1) {
        total += parseInt(values[i], 10) || 0;
    }
    if (annualMonth === true) {
        total = aFixedCharge;
    }
    return total;
};

export const selectTotalFixed = createSelector(
    totalFixed,
    sum => sum,
);

const totalkWhs = (state) => {
    const { monthlyKWh, annualKWH } = state.utility;
    const { annualMonth } = state.settings;

    let total = 0;
    const values = Object.values(monthlyKWh);
    for (let i = 0; i < values.length; i += 1) {
        total += parseInt(values[i], 10) || 0;
    }
    if (annualMonth === true) {
        total = annualKWH;
    }
    return total;
};

export const selectTotalkWh = createSelector(
    totalkWhs,
    totalkWh => totalkWh,
);

export const formattedAnnualBill = (year, prevEnergyValue, state) => {
    const bill = annualEnergyValueForYear(year, prevEnergyValue, state) * selectTotalkWh(state);
    return bill.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
};

export const annualBill = (year, prevEnergyValue, state) => {
    const bill = annualEnergyValueForYear(year, prevEnergyValue, state) * selectTotalkWh(state);
    return bill;
};



// WEBPACK FOOTER //
// ./src/containers/common/utility/selectors.js